export type Dictionary<T> = Record<string, T>;
export type InputTextMask = (RegExp | string)[] | boolean;
export enum SharedComponentViewType {
  ACCOUNT,
  VENUE,
}
